import React, { useEffect } from 'react';
import styles from './Quiz.module.css';
import ActiveQuiz from '../../components/ActiveQuiz';
import FinishedQuiz from '../../components/FinishedQuiz';
import Loader from '../../components/UI/Loader';
import { connect } from 'react-redux';
import { fetchQuizById, quizAnswerClick, retryQuiz } from '../../store/actions/quiz';
import { func, bool, number, shape, arrayOf, string, object } from 'prop-types';

const Quiz = ({
  loading, quiz, results, isFinished, error, retryQuiz, activeQuestion, quizAnswerClick,
  answerState, fetchQuizById, match: { params: { id } }
}) => {
  useEffect(() => {
    fetchQuizById(id)

    return () => retryQuiz()
  }, [id]) //eslint-disable-line

  return (
    <div className={styles.quiz}>
      <div className={styles.quizWrapper}>
        <h1>Ответьте на все вопросы</h1>
        {
          loading || !quiz
            ? <Loader />
            : error ? <p className={styles.error}>Во время загрузки вопроса произошла ошибка.</p> : isFinished
              ? <FinishedQuiz
                results={results}
                quiz={quiz}
                onRetry={retryQuiz}
              />
              : <ActiveQuiz
                answers={quiz[activeQuestion].answers}
                question={quiz[activeQuestion].question}
                onAnswerClick={quizAnswerClick}
                quizLength={quiz.length}
                answerNumber={activeQuestion + 1}
                state={answerState}
              />
        }
      </div>
    </div>
  )
}

Quiz.propTypes = {
  loading: bool,
  quiz: arrayOf(shape({
    question: string,
    id: number.isRequired,
    rightAnswerId: number.isRequired,
    answers: arrayOf(shape({
      text: string,
      id: number.isRequired,
    }))
  })),
  results: object,
  isFinished: bool,
  answerState: object,
  activeQuestion: number,
  fetchQuizById: func,
  quizAnswerClick: func,
  retryQuiz: func,
}

Quiz.defaultProps = {
  loading: false,
  quiz: {},
  results: {},
  isFinished: false,
  activeQuestion: 0,
  answerState: {},
  fetchQuizById: () => { },
  quizAnswerClick: () => { },
  retryQuiz: () => { },
}

export default connect(({ quiz: { results, isFinished, activeQuestion, answerState, quiz, loading, error } }) => ({
  loading, error, quiz, results, isFinished, activeQuestion, answerState
}), { fetchQuizById, quizAnswerClick, retryQuiz })(Quiz);